export default __webpack_public_path__ + "f77e34b79b1dd7efa51b41eeae0dc002.png";